// src/hooks/usePlayground.ts
import { useState, useEffect } from 'react';
import { PlaygroundData, PlaygroundParams } from '../types/playground';
import { PlaygroundService } from '../services/playgroundService';

export const usePlayground = (params: PlaygroundParams, shouldFetch: boolean = false) => {
  const [data, setData] = useState<PlaygroundData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
      
    let dataAchieved: boolean;

    const fetchWithRetry = async (retries = 3, delay = 1000) => {
      let lastError: Error | null = null;
      for (let attempt = 1; attempt <= retries; attempt++) {
        try {
          const response = await PlaygroundService.getPlaygroundURL(params);
          
          if (response !== null && response !== undefined) {
            setError(null);
            setData(response);
            dataAchieved = true;
            break;
          }
          lastError = new Error('Playground service returned null or undefined');
        } catch (err) {
          lastError = err as Error;
          console.error(`Playground fetch error (attempt ${attempt}/${retries}):`, err);
        }
          if (attempt < retries) {
            const backoffDelay = delay * Math.pow(2, attempt - 1);
            console.log(`Retrying in ${backoffDelay}ms...`);
            await new Promise(resolve => setTimeout(resolve, backoffDelay));
          }
        }
      
      if(!dataAchieved) {
        setData(null);
        setError(null);
      }
      return false;
    };

    const fetchData = async () => {
      if (!shouldFetch) return;
      
      setIsLoading(true);
      setError(null);
      
      try {
        await fetchWithRetry();
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [
    params.notebook_name,
    params.username,
    shouldFetch
  ]);

  return { data, isLoading, error };
};
